import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import {
  PageContainer,
  HeroImageSection,
  HeroImageWrap,
  HeroImage,
  MainSection,
  PageTitle,
  PageParagraph,
} from '../SimplePage/SimplePageElements';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=900&q=80';

const Careers = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <PageContainer>
        <HeroImageSection>
          <HeroImageWrap>
            <HeroImage src={HERO_IMAGE} alt="Team and workplace collaboration" />
          </HeroImageWrap>
        </HeroImageSection>
        <MainSection>
          <Link to="/" style={{ color: '#01bf71', fontWeight: 600, textDecoration: 'none', marginBottom: 32, display: 'inline-block' }}>
            ← Back to Home
          </Link>
          <PageTitle>Careers</PageTitle>
          <PageParagraph>
            No positions available at the moment.
          </PageParagraph>
          <PageParagraph>
            We’re always interested in hearing from talented people. If you’d like to be considered
            for future roles, send us your details via the Contact Us page and we’ll keep you in mind.
          </PageParagraph>
          <PageParagraph>
            <Link to="/contactus" style={{ color: '#01bf71', fontWeight: 600 }}>
              Contact us →
            </Link>
          </PageParagraph>
        </MainSection>
      </PageContainer>
      <Footer />
    </>
  );
};

export default Careers;
